"use client";
import Stack from "@mui/material/Stack";
import Anchor from "@/components/common/Anchor";
import ConsentField from "@/components/site-builder/modules/CustomFormModule/components/FormPrivacyConsent/ConsentField";
import { replaceConsentText } from "@/components/site-builder/modules/CustomFormModule/utils/consent/replaceConsentText";
import TextField from "@/components/site-builder/TextField";
import { FormBuilderConsentFieldNames } from "@/constants/form-builder";
import { useSiteAnalyticsContext } from "@/context/siteAnalytics";
import { type FormBuilderConsentConfig } from "@/types/form-builder";
import { createBasicTextFieldObject } from "@/utils/site-builder/createBasicTextFieldObject";
import s from "./FormPrivacyConsent.module.scss";

export interface FormPrivacyConsentProps {
  consentConfig: FormBuilderConsentConfig;
}

export function FormPrivacyConsent(props: FormPrivacyConsentProps) {
  const {
    consentConfig: {
      privacyLinkTitle,
      privacyLink,
      combined,
      marketing,
      thirdParty,
      extraStatement,
      privacyStatement,
    },
  } = props;

  const {
    site: { title: siteName },
  } = useSiteAnalyticsContext();

  return (
    <Stack spacing={2} className={s.privacyConsent}>
      {combined.shown && combined.text && (
        <ConsentField
          name={FormBuilderConsentFieldNames.CombineMarketing}
          type={combined.inputType}
          text={combined.text}
          required={combined.required}
          siteName={siteName}
        />
      )}
      {marketing.shown && marketing.text && (
        <ConsentField
          name={FormBuilderConsentFieldNames.Marketing}
          type={marketing.inputType}
          text={marketing.text}
          required={marketing.required}
          siteName={siteName}
        />
      )}
      {thirdParty.shown && thirdParty.text && (
        <ConsentField
          name={FormBuilderConsentFieldNames.ThirdParty}
          type={thirdParty.inputType}
          text={thirdParty.text}
          required={thirdParty.required}
          siteName={siteName}
        />
      )}
      <Stack>
        {privacyLink && privacyLinkTitle && (
          <Anchor href={privacyLink} openInNewTab>
            {privacyLinkTitle}
          </Anchor>
        )}
        {extraStatement && (
          <div>
            <TextField
              type="text-small"
              field={createBasicTextFieldObject(
                replaceConsentText({
                  text: extraStatement,
                  siteName,
                }),
              )}
            />
          </div>
        )}
        {privacyStatement && (
          <div>
            <TextField
              type="text-small"
              field={createBasicTextFieldObject(
                replaceConsentText({
                  text: privacyStatement,
                  siteName,
                }),
              )}
            />
          </div>
        )}
      </Stack>
    </Stack>
  );
}
